<template>
  <div
    class="form-group-simple"
    :class="{
      'form-group-simple--completed': completed
    }"
  >
    <label for="PolicyNumber">{{ label }}</label>

    <input
      ref="input"
      :class="errorMessage ? 'error' : ''"
      v-model="inputValue"
      type="text"
      name="PolicyNumber"
      maxlength="15"
      minlength="1"
      @blur="blur"
      @input="update($event.target.value)"
      placeholder="000001010"
    />

    <div class="form-group-simple__details" v-if="errorMessage">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error">
          <span> <v-error-icon></v-error-icon> {{ errorMessage }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useField } from 'vee-validate';
import { ref, onBeforeMount, watch, getCurrentInstance } from 'vue';
import VErrorIcon from 'icons/AlertCircle';
import { generateYupSchema } from '@/composables/globalHelperFunctions';

export default {
  name: 'VInputPolicynumberSimple',
  components: {
    VErrorIcon
  },
  props: {
    id: {
      default: '',
      type: String
    },
    name: {
      default: 'PolicyNumber',
      type: String
    },
    autofocus: {
      default: false,
      type: Boolean
    },
    label: {
      default: '',
      type: String
    },
    rules: {
      default: null,
      type: Object
    }
  },
  setup(props) {
    const instance = getCurrentInstance();
    const inputValue = ref(props.value);
    const schema = ref(generateYupSchema(props));
    const { value, errorMessage, validate } = useField(props.id, schema);

    watch(
      () => props.rules,
      () => {
        schema.value = generateYupSchema(props);
      }
    );
    const completed = ref(false);

    const focus = () => {};

    const blur = () => {
      validate();
    };

    const update = async (updatedValue) => {
      inputValue.value = updatedValue;
      value.value = updatedValue;
      let result = await validate();
      instance.emit('updateValidation', result.valid);
    };

    onBeforeMount(() => {
      if (props.value) {
        value.value = ref(props.value);
      }
    });

    return {
      inputValue,
      completed,
      focus,
      blur,
      update,
      errorMessage
    };
  }
};
</script>
<style lang="scss" scoped>
.error {
  border: 1px solid $pure-red;
}
.form-group-simple {
  position: relative;
  &__error .alert-circle-icon {
    display: inline-flex;
    width: 16px;
    height: 16px;
    fill: $pure-red;
    vertical-align: bottom;
  }
}
</style>
